<agpr-take-over-panel
    [id]="id"
    class="agpr-precisionClip"
    header="Monitor.precisionClip.setup.header"
    [width]="35"
    headerIcon="fa-kit-duotone fa-agpr-ai-generic"
    [overlayContainer]="overlayContainer"
    [hideSlideOverlay]="hideSlideOverlay"
    [animationTrigger]="animationTrigger"
    (visibleChange)="onVisibleChange($event)"
>
    <div>
        <h3 class="agpr-precisionClip-heading"> {{ 'Monitor.precisionClip.setup.broadcast.mention.header' | localize }} </h3>
        <div class="agpr-precisionClip-group">
            <agpr-radio
                [id]="id + '_mentionSelectionOption'"
                [value]="mentionSelectionEnum.MENTIONS_IN_SECTION"
                [(ngModel)]="mentionSelection"
                (ngModelChange)="handleNumberOfMentions()"
                [label]="'Monitor.precisionClip.setup.mention.section.option' | localize: { name: curatedBlockName }"
                [hiddenLabel]="'Monitor.precisionClip.setup.mention.section.option' | localize: { name: curatedBlockName }"
            ></agpr-radio>

            <agpr-radio
                [id]="id + '_all_saved_mentionOption'"
                [value]="mentionSelectionEnum.ALL_SAVED_MENTIONS"
                [(ngModel)]="mentionSelection"
                (ngModelChange)="handleNumberOfMentions()"
                label="Monitor.precisionClip.setup.all.saved.mention.option"
                hiddenLabel="Monitor.precisionClip.setup.all.saved.mention.option"
            ></agpr-radio>

            <agpr-message
                [severity]="messageSeverityEnum.info"
                [bottomMargin]="false"
            >
                <b>{{ 'Monitor.precisionClip.setup.number.mention.header' | localize: { count: numPrecisionClipMentions }  }}</b><br/>
                {{ 'Monitor.precisionClip.setup.number.mention.body' | localize }}
            </agpr-message>

            @if (numPrecisionClipMentions >= MENTION_LIMIT) {
                <agpr-message
                    [severity]="messageSeverityEnum.warning"
                    agprTooltip="Briefings.blockType.precisionClip.limitFeedback.tooltip"
                    [bottomMargin]="false"
                >
                    {{ 'Briefings.blockType.precisionClip.limitFeedback' | localize }}
                </agpr-message>
            }
        </div>
    </div>

    <div>
        <h3 class="agpr-precisionClip-heading"> {{ 'Monitor.precisionClip.setup.header' | localize }} </h3>
        <div class="agpr-precisionClip-group">
            <div>
                <h6 class="agpr-headerH3-dark">
                    {{ 'Monitor.precisionClip.setup.keyword.heading' | localize }}
                </h6>

                <div
                    class="agpr-precisionClip-group"
                    role="radiogroup"
                    [attr.aria-label]="'Monitor.precisionClip.setup.keyword.heading' | localize"
                >
                    <div class="agpr-precisionClip-group">
                        <agpr-radio
                            [id]="id + '_savedMentionKeywordOption'"
                            [value]="keywordSelectionEnum.SAVED_MENTION"
                            [(ngModel)]="keywordSelection"
                            (ngModelChange)="keywordSelectionChange($event)"
                            label="Monitor.precisionClip.keyword.option.mention"
                            hiddenLabel="Monitor.precisionClip.keyword.option.mention"
                            tooltip="Monitor.precisionClip.keyword.option.mention.tooltip"
                        ></agpr-radio>
                        @if (keywordSelection === keywordSelectionEnum.SAVED_MENTION) {
                            <div class="agpr-precisionClip-indent">
                                <agpr-text-input-chips
                                    [id]="id + '_fallbackKeywords'"
                                    class="agpr-precisionClip-keyword-input"
                                    placeholder="Monitor.precisionClip.setup.fallback.keyword.placeholder"
                                    header="Monitor.precisionClip.setup.fallback.keyword"
                                    tooltip="Monitor.precisionClip.setup.fallback.keyword.tooltip"
                                    [(ngModel)]="fallbackKeywords"
                                    (ngModelChange)="handleNumberOfMentions()"
                                ></agpr-text-input-chips>
                            </div>
                        }
                    </div>
                    <div class="agpr-precisionClip-group">
                        <agpr-radio
                            [id]="id + '_manualKeywordOption'"
                            [value]="keywordSelectionEnum.MANUAL"
                            [(ngModel)]="keywordSelection"
                            (ngModelChange)="keywordSelectionChange($event)"
                            label="Monitor.precisionClip.setup.keyword.option.manual"
                            hiddenLabel="Monitor.precisionClip.setup.keyword.option.manual"
                        ></agpr-radio>

                        @if (keywordSelection === keywordSelectionEnum.MANUAL) {
                            <div class="agpr-precisionClip-indent">
                                <agpr-text-input-chips
                                    [id]="id + '_manualKeywords'"
                                    class="agpr-precisionClip-keyword-input"
                                    placeholder="Mention.workbench.insights.prompt.enterKeywords"
                                    [(ngModel)]="manualKeywords"
                                    (ngModelChange)="handleNumberOfMentions()"
                                ></agpr-text-input-chips>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <div>
                <h6 class="agpr-headerH3-dark">
                    {{ 'Monitor.precisionClip.setup.insights' | localize }}
                </h6>

                <agpr-checkbox
                    [id]="id + '_insightsCheckbox'"
                    label="Monitor.precisionClip.setup.insights.label"
                    [binary]="true"
                    [(ngModel)]="insightsEnabled"
                ></agpr-checkbox>
            </div>

            <div class="agpr-precisionClip-group">
                <agpr-panel
                    [id]="id + '_expertPanel'"
                    class="agpr-precisionClip-panel"
                    header="Monitor.precisionClip.setup.expertSettings"
                    [collapsed]="true"
                    [showCustomHeader]="false"
                    [noBorder]="true"
                >
                    <div class="agpr-precisionClip-panelRow">
                        <agpr-number-input
                            [id]="id + '_extendStartTime'"
                            label='Monitor.precisionClip.setup.extend.start'
                            [(ngModel)]="extendStartTime"
                            [min]="0"
                            [max]="60"
                        ></agpr-number-input>

                        <agpr-number-input
                            [id]="id + '_extendEndTime'"
                            label='Monitor.precisionClip.setup.extend.end'
                            [(ngModel)]="extendedEndTime"
                            [min]="0"
                            [max]="60"
                        ></agpr-number-input>
                    </div>
                </agpr-panel>

                <agpr-message [severity]="messageSeverityEnum.warning">
                    {{ 'Monitor.precisionClip.setup.warning' | localize }}
                </agpr-message>
            </div>
        </div>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_PrecisionClipButton'"
            label="Monitor.precisionClip.setup.precisionClip"
            [style]="buttonType.primary"
            [tooltip]="precisionClipTooltip"
            [disabled]="numPrecisionClipMentions === 0 || (keywordSelection === keywordSelectionEnum.MANUAL && manualKeywords.length === 0)"
            (click)="confirm()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
